
export const sFechaPublicacion = '2026-08-23T15:57:27.8665788-06:00';
export const sVersion = 'vf1.1.608231557';
            